import React from 'react';
import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { toggleBillingModal } from '@redux/actions/modalAction';
import { CrossIcon, DiamondUpgradeIcon } from '@icons';
import './UpgradeModal.less';

type UpgradeModalProps = {
  visible: boolean;
  onCloseUpgradeModal: () => void;
};

export default function UpgradeModal({
  visible = false,
  onCloseUpgradeModal
}: UpgradeModalProps) {
  const dispatch = useDispatch();

  const onUpgrade = () => {
    dispatch(toggleBillingModal({ visible: true }));
    onCloseUpgradeModal();
  };

  return (
    <Modal
      open={visible}
      onCancel={onCloseUpgradeModal}
      footer={null}
      centered={true}
      width={434}
      destroyOnClose
      zIndex={1015}
      className="approval-upgrade-modal"
    >
      <CrossIcon
        className="approval-upgrade-modal_close"
        onClick={onCloseUpgradeModal}
      />
      <div className="approval-upgrade-modal_icon">
        <DiamondUpgradeIcon className="upgrade-icon" />
      </div>
      <div className="approval-upgrade-modal_title">
        Save time with approval templates.
      </div>
      <div className="approval-upgrade-modal_text">
        Reuse preset stages and reviewers to streamline workflows and get
        sign-off faster.
      </div>
      <div className="approval-upgrade-modal_buttons">
        <Button
          type="primary"
          style={{
            minWidth: 136
          }}
          icon={<DiamondUpgradeIcon className="upgrade-icon" />}
          onClick={onUpgrade}
        >
          Upgrade
        </Button>
        <Button type="text" onClick={onCloseUpgradeModal}>
          No, thanks
        </Button>
      </div>
    </Modal>
  );
}
